import { AMPLITUDE_EVENT } from '@sonar-software/sonar-analytics';
import { Import } from '@sonar-software/sonar-imports';
import { SyncEntry } from './SyncEntry';
import { useAmplitude } from '@hooks';
import React, { useCallback } from 'react';

export interface SyncListProps {
	syncs: Import[];
}

export const SyncList: React.FC<SyncListProps> = ({ syncs }) => {
	const log = useAmplitude();

	const handleClick = useCallback(() => log(AMPLITUDE_EVENT.LOGS_VIEWED), [ log ]);

	return (
		<>
			{ syncs.map((sync) =>
				<SyncEntry
					key={ sync.id }
					onClick={ handleClick }
					sync={ sync } />) }
		</>
	);
};
